<div>
  <ngb-carousel>
    @for(slide of slides; track slide.id) {
        <ng-template ngbSlide >
        <div class="picsum-img-wrapper img-container" >
            <img class="img-carousel" [src]="slide?.imageSlide?.url" alt="Random first slide" />
        </div>
        <div class="carousel-text d-flex flex-column">
            <span class="title mb-4">{{slide?.title}}</span>
            <span class="subtitle mb-4">{{slide?.subtitle}}</span>
            <span class="descripcion">{{slide?.fullDescription}}</span>
        </div>
      </ng-template>
    }
  </ngb-carousel>
</div>
 